module.exports = __webpack_public_path__ + "img/py_list_bkzs_selected.3ac73fc0.png";